module.exports = __webpack_public_path__ + "img/爱心.f2762d7a.png";